import { z } from "zod";
import { nonEmptyString } from "./nonEmptyString.js";

export const dogInputSchema = z.object({
	birthdate: nonEmptyString,
	breed: nonEmptyString,
	callName: nonEmptyString,
	registeredName: nonEmptyString,
	chipNumber: nonEmptyString,
	handlerOwner: nonEmptyString.optional(),
});
